<template>
  <div>
    <div class="bookDetails">
      <p><img :src="publication.picture_url" /></p>
      <dl>
        <dt>Title</dt>
        <dd class="details-booktitle">{{ publication.title }}</dd>
        <dt>Author</dt>
        <dd class="details-authorlist" v-for="author in publication.authors">
          <router-link 
            v-if=!embed
            :to="`/author/${author.guid}`">{{ author.name }}
          </router-link>
          <span v-else>{{author.name}}</span>
        </dd>
        <dt>actions</dt>
        <dd v-if=!embed @click="showPublicationFull">Publication Details</dd>
        <dd v-if=!embed @click="showButtonsDialog">Reshelf</dd>
        <dd @click="showDatesDialog" v-if="!embed && publication.bookId">Your copy</dd>
      </dl>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import ShelfPicker from "../components/ShelfPicker"
import BookDatePicker from "../components/BookDatePicker"
import FullPublicationDetails from "../components/FullPublicationDetails"

export default {
  name: "publicationDetails",
  props: ["publication"],
  components: {
    "shelf-picker": ShelfPicker
  },
  data() {
    return {
      embed: !(typeof this.$route.query.embed === 'undefined') && this.$route.query.embed !== 'false'
    };
  },
  methods: {
    showButtonsDialog() {
      this.$modal.show(ShelfPicker,
        {
          publication: this.publication
        },
        {
          height: "auto"
        },
        {
          "before-close": event => {
            this.$eventHub.$emit('refresh-shelves');
          }
        }
      );
    }, 
    showDatesDialog() {
      this.$modal.show(BookDatePicker,
        {
          publication: this.publication
        },
        {
          height: "auto"
        },
        {
          "before-close": event => {
            // this.$eventHub.$emit('refresh-shelves');
          }
        }
      );
    }, 
    showPublicationFull() {

      this.$modal.show(FullPublicationDetails,
        {
          publicationId: this.publication.publicationId || this.publication.guid
        },
        {
          height: "auto",
          scrollable: true,
          adaptive: true
        },
        {
          "before-close": event => {
            // this.$eventHub.$emit('refresh-shelves');
          }
        }
      );
    }
  }
};
</script>
